const environment = {
    ENV:"",
    VERSION:""
};

  export default environment;